import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import SydLabel from '../../../commonDesign/SydLabel'
import FundingStatusBadge from './FundingStatusBadge'

const useStyles = makeStyles(() => ({
  goalHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  goalResults: {
    display: 'flex',
    flexDirection: 'column'
  },
  goalResult: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '.2rem 0'
  },
  detailText: {
    fontSize: '0.9rem',
    color: 'var(--color-neutral-700)'
  },
  funded: {
    backgroundColor: '#d3edf9',
    color: '#3d7597'
  },
  notFunded: {
    backgroundColor: '#e5e7eb'
  },
  statusContainer: {
    '& > div': {
      borderRadius: '.2rem',
      padding: '.3rem .5rem'
    }
  }
}))

function GoalSummaryItem ({ goal, actions, actionItemProps }) {
  const styles = useStyles()
  const statusText = goal.isFunded ? 'Funded' : 'Not Funded'
  const statusClass = goal.isFunded ? styles.funded : styles.notFunded

  return (
    <div className='opal-card-md' key={goal.goalName}>
      <div className={styles.goalHeader}>
        <SydLabel label={goal.goalName} style={{ fontSize: '1.2rem' }} />
        <div className={styles.statusContainer}>
          <FundingStatusBadge
            statusText={statusText}
            className={statusClass}
          />
        </div>
      </div>
      <div className={styles.goalResults}>
        {goal.goalResults.map(r => {
          return (
            <div className={styles.goalResult} key={r.label}>
              <SydLabel label={r.label} />
              <SydLabel label={r.value} />
            </div>
          )
        })}
      </div>
      {actionItemProps.include && !!actions?.length && (
        <div className={styles.goalActions}>
          <div>
            <SydLabel label={actionItemProps?.title ?? 'Action Items'} />
            {actions.map(a => (
              <li className={styles.detailText} style={actionItemProps.styles} key={a.text}>{a.text}</li>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

GoalSummaryItem.propTypes = {
  goal: PropTypes.shape({
    goalName: PropTypes.string.isRequired,
    isFunded: PropTypes.bool.isRequired,
    goalResults: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })).isRequired
  }).isRequired,
  actions: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired
  })),
  actionItemProps: {
    include: PropTypes.bool,
    accessor: PropTypes.string,
    title: PropTypes.string,
    styles: PropTypes.object
  }
}

GoalSummaryItem.defaultProps = {
  actionItemProps: {
    include: true,
    accessor: 'actions',
    title: 'Action Items',
    styles: {}
  }
}

export default GoalSummaryItem
